import './App.scss';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Main from './screens/main/Main';
import AdminMain from './Admin/AdminRouter';
import MainCompt from './screens/company/MainCompt';
import MainBoardRouter from './screens/board/MainBoardRouter';
import MypageMain from './screens/mypage/MypageRouter';
import MainLogin from './screens/login/MainLogin';
import RecruitRouter from './screens/recruit/RecruitRouter';
import ApplyRouter from './screens/apply/ApplyRouter';
import ChurchProfile from './screens/recruit/common/ChurchProfile';
import MinisterRouter from './screens/minister/MinisterRouter';
import RetreatRouter from './screens/retreat/RetreatRouter';
import MainAiserviceRouter from './screens/aiservice/MainAiserviceRouter';
import PastorRouter from './screens/pastor/PastorRouter';


// 예전에 공유된 /ministerpage?id=<ministerMain id> 링크를 옮겨 온 프로필페이지로 넘긴다
function LegacyMinisterPageRedirect() {
  const { search } = useLocation();
  const legacyId = new URLSearchParams(search).get('id') || '';
  return <Navigate to={`/minister/profilepage/detail?legacyId=${encodeURIComponent(legacyId)}`} replace />;
}

function App() {

  return (
      <div className="App">

          <div className='Main'>

            <Routes>
              <Route path="/" element={<Main/>}/>
              <Route path="/pastor/*" element={<PastorRouter/>}/>
              <Route path="/recruit/*" element={<RecruitRouter/>}/>
              <Route path="/church/:id" element={<ChurchProfile/>}/>
              <Route path="/apply/*" element={<ApplyRouter/>}/>

              <Route path="/minister/*" element={<MinisterRouter/>}/>
              {/* 예전 프로필페이지 주소 — /minister/profilepage/detail 로 이동 */}
              <Route path="/ministerpage" element={<LegacyMinisterPageRedirect/>}/>
              <Route path="/retreat/*" element={<RetreatRouter/>}/>

              <Route path="/aiservice/*" element={<MainAiserviceRouter/>}/>

              <Route path="/board/*" element={<MainBoardRouter/>}/>
              
              <Route path="/company/*" element={<MainCompt/>}/>
              
              <Route path="/mypage/*" element={<MypageMain/>}/>
              <Route path="/login/*" element={<MainLogin/>}/>
              <Route path="/admin/*" element={<AdminMain/>}/>
           
              
            </Routes>
          </div>

      </div>
  );
}

export default App;
